import { render } from "./PreviewModal.vue?vue&type=template&id=52c34e64&scoped=true"
import script from "./PreviewModal.vue?vue&type=script&lang=js"
export * from "./PreviewModal.vue?vue&type=script&lang=js"

import "./PreviewModal.vue?vue&type=style&index=0&id=52c34e64&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\ft\\Coding\\GT Designer\\gtdesigner\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c34e64"]])

export default __exports__